import { render, staticRenderFns } from "./PolicyPrint.vue?vue&type=template&id=462f291f&"
import script from "./PolicyPrint.vue?vue&type=script&lang=js&"
export * from "./PolicyPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports